import Step3 from '../Components/Step3/Step3';
import { StepNavigationHeader } from '@modules/Steps/Shared/Widgets/StepsNavigationHeader/StepsNavigationHeader';
import Breadcrumbs from '@shared/Widgets/Navigation/Breadcrumbs/Breadcrumbs';
import { BREADCRUMBS_LABELS } from '@configs/BreadcrumbsLabels';
import { useParams } from 'react-router-dom';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';

const Step3Page: React.FC = () => {
    const [isDesktop] = useMediaType();

    return (
        <>
            {isDesktop && (
                <Breadcrumbs items={BREADCRUMBS_LABELS.CREATE_NEW_PROJECT} />
            )}
            <StepNavigationHeader />
            <Step3 />
        </>
    );
};

export default Step3Page;
